import type { LeadsSearchFilterKey } from "app/pages/sales-intelligence/modules/leads-search-filters";
import SIAllTrackersService from "app/pages/sales-intelligence/services/tracking/SIAllTrackersService";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { AllTrackersBaseService } from "app/services/track/AllTrackersService";

const LEADS_SEARCH_FILTERS_TRACKING_ACTION = {
    click: "click",
    search: "search",
    selectValue: "select value",
    deleteValue: "delete value",
    clearFilter: "clear filter",
} as const;

const valueOperationMap = {
    add: "add",
    remove: "remove",
} as const;

type LeadsSearchFiltersTrackingAction =
    (typeof LEADS_SEARCH_FILTERS_TRACKING_ACTION)[keyof typeof LEADS_SEARCH_FILTERS_TRACKING_ACTION];

export default function createLeadsSearchFiltersTrackingService(tracker: AllTrackersBaseService) {
    const track: AllTrackersBaseService["dispatchTrackEvent"] = tracker.dispatchTrackEvent.bind(tracker);

    function trackEvent(
        action: LeadsSearchFiltersTrackingAction,
        eventName: string | number,
        eventSubName?: string | number,
        eventSubSubName?: string | number,
        eventExtra?: string | number,
    ): void {
        const event: string = createTrackingEventName(eventName, eventSubName, eventSubSubName, eventExtra);

        track("filters panel", action, event);
    }

    return {
        setSignalsCount(count: number) {
            if (tracker instanceof SIAllTrackersService) {
                tracker.setCustomTrackingParams({
                    signalsCount: count,
                });
            }
        },
        trackFilterValueChange(filterName: string, tabName: string, filterValue: string) {
            trackEvent(LEADS_SEARCH_FILTERS_TRACKING_ACTION.selectValue, filterName, tabName, filterValue);
        },
        trackFilterValueClear(filterName: string, tabName: string) {
            trackEvent(LEADS_SEARCH_FILTERS_TRACKING_ACTION.deleteValue, filterName, tabName);
        },
        trackFilterClearAll() {
            trackEvent(LEADS_SEARCH_FILTERS_TRACKING_ACTION.click, "clear all");
        },
        trackSearchFilterApply(filterKey: LeadsSearchFilterKey, searchTerm: string) {
            trackEvent(LEADS_SEARCH_FILTERS_TRACKING_ACTION.click, "applied filter", filterKey, searchTerm);
        },

        filters: {
            trackSiteTagsValueDelete(value: string) {
                track("lead gen filters", "click", createTrackingEventName(value, valueOperationMap.remove, "tag"));
            },
            trackSiteTagsValueAdd(value: string) {
                track("lead gen filters", "click", createTrackingEventName(value, valueOperationMap.add, "tag"));
            },
        },
    };
}
